import React, { Component } from 'react'

import PropTypes from 'prop-types'
import isFunction from 'lodash/isFunction'

import { isObject } from './../../libs/utils'

export default class FormControl extends Component {
  static propTypes = {
    onChangeExternal: PropTypes.func,
    onChange: PropTypes.func
  }

  state = {
    isValid: true,
    errorMessage: null,
    value: ''
  }

  componentWillMount() {
    const { initialValue, id, onChange } = this.props
    const state = {}

    let defaultState = {}

    if (this.getDefaultState) {
      defaultState = this.getDefaultState()
    }

    if (initialValue) {
      state.value = initialValue

      if (onChange) {
        onChange(id, initialValue)
      }
    }

    this.setState({
      ...defaultState,
      ...state
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialValue !== nextProps.initialValue) {
      this.setState(
        {
          value: nextProps.initialValue
        },
        () => {
          if (this.props.onChange) {
            this.props.onChange(this.props.id, nextProps.initialValue)
          }
        }
      )
    }

    if (nextProps.revalidate) {
      this.validate()
    }
  }

  componentWillUnmount() {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.id)
    }
  }

  overrideValue(value) {
    this.setState({ value })
  }

  isValid = value => {
    const { validationFuncs } = this.props

    let valid = true
    let errorMessage = null

    if (Array.isArray(validationFuncs) && validationFuncs.length) {
      const invalidResults = validationFuncs.map(validationFunc => validationFunc(value)).filter(result => result.error)

      if (invalidResults.length) {
        valid = false
        errorMessage = invalidResults[0].errorMessage
      }
    }

    return {
      valid,
      errorMessage
    }
  }

  validate = () => {
    const value = this.getValue()
    const { valid, errorMessage } = this.isValid(value)

    this.setState({
      isValid: valid,
      errorMessage
    })

    if (isFunction(this.props.formValid)) {
      this.props.formValid(this.props.id, valid)
    }
  }

  getCheckedValue = value => {
    if (value === null || (isObject(value) && !value.type) || Array.isArray(value) || typeof value === 'string') {
      return value
    } else if (this.getChangeValue) {
      return this.getChangeValue()
    } else if (isObject(value) && value.target) {
      return value.target.value
    } else {
      return this.refs[this.props.id].value
    }
  }

  handleChange = val => {
    const value = this.getCheckedValue(val)

    this.setState({ value }, () => {
      if (isFunction(this.props.onChange)) {
        this.props.onChange(this.props.id, value)
      }
      if (isFunction(this.props.onChangeExternal)) {
        this.props.onChangeExternal(this.props.id, value)
      }
    })
  }

  onAfterChange = () => {
    if (isFunction(this.props.onAfterChange)) {
      this.props.onAfterChange()
    }
  }

  render() {
    return <div />
  }
}



// WEBPACK FOOTER //
// src/components/UI/FormControl.jsx